export default __webpack_public_path__ + "static/media/Nunito-Medium.a7c01ee7.ttf";